import React from 'react';
import Button from 'components/Buttom/Button';
import { Container } from './styles';
import { useHistory } from 'react-router-dom';
// import { Anchor } from 'common/SocialMedia/styles';

export const ExcursionOrganizatorBox = (): JSX.Element => {
  const history = useHistory();
  return (
    <Container>
      <h1>Organizando uma Excursão?</h1>
      {/* <Anchor href="https://marcuscosta12.wixsite.com/portosegurotur/blank-1" target="_blank" rel="noreferrer">
        <Button text="Cadastrar Excursão" />
      </Anchor> */}
      <Button
        text="Cadastrar Excursão"
        onClick={() => {
          {
            /* Forma de cadastro do portal que foi descontinuada */
          }
          {
            /*  history.push('/login/admin', { profile: 1 });*/
          }
          window.open('https://tts.vivaportoseguro.app/', '_blank');
        }}
      />
    </Container>
  );
};
